import { COUNTY_NEIGHBORHOODS } from "@/lib/neighborhoods";

/**
 * Grouped native <select> for picking a neighbourhood.
 * Uses optgroups for Nairobi / Kiambu / Mombasa for accessibility & mobile UX.
 */
export default function NeighborhoodSelect({
  value = "",
  onChange,
  placeholder = "Select a neighbourhood",
  testId = "neighborhood-select",
  className = "",
  id,
  disabled = false,
}) {
  // If the user's current value isn't in our grouped list, still show it
  // (so custom / legacy neighbourhoods don't disappear).
  const known = COUNTY_NEIGHBORHOODS.flatMap((c) => c.hoods);
  const showCustom = value && !known.includes(value);

  return (
    <select
      id={id}
      data-testid={testId}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.value)}
      className={
        "h-11 w-full rounded-full border border-black/10 bg-white px-4 pr-9 text-sm text-[#1A1A1A] " +
        "focus:outline-none focus:ring-2 focus:ring-[#D95D39] disabled:opacity-60 " +
        className
      }
    >
      <option value="">{placeholder}</option>
      {showCustom && (
        <optgroup label="Your neighbourhood">
          <option value={value}>{value}</option>
        </optgroup>
      )}
      {COUNTY_NEIGHBORHOODS.map(({ county, hoods }) => (
        <optgroup key={county} label={county}>
          {hoods.map((h) => (
            <option key={`${county}-${h}`} value={h}>
              {h}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
